import {SimplePage} from "../../elements/Pages";
import React from "react";

import {useQuery} from "@tanstack/react-query";
import {useAuth} from "../../../contexts/AuthContext";
import ListViewTable, {TableLink} from "../../elements/tables/ListViewTable";
import {DownloadButton, PrimaryButton} from "../../elements/Buttons";
import {getStudents, getStudentsBasicExcel} from "../../../api/school";
import env from "react-dotenv";
import {getRegistrations, getRegistrationsExcel} from "../../../api/summer_school";

const columns = [
    {
        accessorFn: (row) => `${row.last_name}, ${row.first_name}`,
        id: "student_search",
        header: "SchülerIn",
        hide: true,
        enableColumnFilter: false,
    },
    {
        accessorFn: (row) => row,
        id: "student",
        header: "SchülerIn",
        columnType: "student",
        enableColumnFilter: false,
        sortingFn: "lastNameSorting",
    },
    {
        accessorKey: "get_status_display",
        id: "get_status_display",
        header: "Status",
        enableColumnFilter: true,
        headerClassNames: "narrow-filter",
    },
    {
        accessorFn: (row) => `${row.grade}`,
        id: "grade",
        header: "Stufe",
        enableColumnFilter: true,
        headerClassNames: "narrow-filter",
        filterFn: "containsString",
    },
    {
        accessorKey: "student_status",
        id: "student_status",
        header: "Schülerstatus",
        enableColumnFilter: true,
        headerClassNames: "narrow-filter",
    },
    {
        accessorKey: "requested_subject.name",
        id: "requested_subject",
        header: "Fach",
        enableColumnFilter: true,
        headerClassNames: "narrow-filter",
        filterFn: "containsString",
    },
    {
        accessorKey: "extra_curricular.name",
        id: "extra_curricular",
        header: "Freizeitmodul",
        enableColumnFilter: true,
        headerClassNames: "narrow-filter",
        filterFn: "containsString",
    },
    // {
    //     accessorKey: "id",
    //     id: "projects",
    //     cell: (info) => (
    //         <TableLink
    //             label="Projekte"
    //             to={`/projects/students/${info.getValue()}`}
    //         />
    //     ),
    //     disableRowLink: true,
    //     header: "Projekte",
    //     enableColumnFilter: false,
    // },
];

export default function RegistrationList() {

    const {permissions} = useAuth();

    const {isLoading, isError, isSuccess, data, error, refetch} = useQuery(
        ["summer_school_registrations"],
        getRegistrations,
        {refetchInterval: 1000 * 60 * 60 * 24}
    )

    function getRowLink(row) {
        return `/summer-school/registrations/${row.original.id}/edit`;
    }

    return (
        <SimplePage>
            {/*  Simple striped table */}
            <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                    <div className="sm:flex-auto">
                        <h3 className="text-lg leading-6 font-medium text-gray-900 mb-2">
                            Summer School Anmeldungen
                        </h3>
                    </div>
                    <div className="mt-4 sm:mt-0 sm:ml-16 flex gap-2">
                        <PrimaryButton label="Neue Anmeldung" link={`/summer-school/registrations/new`}/>
                        <DownloadButton
                            apiFunction={() => getRegistrationsExcel()}
                            fileName="SummerSchoolAnmeldungen.xls"
                            label="Liste herunterladen"/>
                    </div>
                </div>
                <div className="flex flex-col">
                    <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">

                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                            {isSuccess && data && (
                                <ListViewTable
                                    data={data}
                                    columns={columns}
                                    isLoading={isLoading}
                                    disableGlobalSearch={false}
                                    rowSelection={null}
                                    setRowSelection={null}
                                    getRowLink={getRowLink}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </SimplePage>
    );
}
